import type { FeatureManifest } from '../registry.js';

/** SO-04 share composer (SCR-08) and SO-03 beat-my-score links. */
export default {
  id: 'share',
  flag: 'share',
  provides: ['shareComposer', 'shareCard', 'beatShare'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
